module.exports = __webpack_public_path__ + "static/media/balls.761d0ef1.mp3";